const CODE_CAMERA_NOT_FOUND = 1002;
const CODE_INVALID_PARAMS = 1011;
const DUPLICATE_TEXT = 'already exists';

const readGraphQLErrors = (error) => {
  const errors = error?.errorData?.errors;
  if (Array.isArray(errors)) return errors;
  return [];
};

const hasDuplicateMessage = (error, graphQLErrors) => {
  const messages = graphQLErrors.map((item) => item?.errorInfo?.message || item?.message);
  messages.push(error?.error);
  return messages.some(
    (message) => typeof message === 'string' && message.toLowerCase().includes(DUPLICATE_TEXT)
  );
};

// Duplicate requests arrive with the generic code 1001, so the message is checked first.
export const mapRequestError = (error) => {
  const graphQLErrors = readGraphQLErrors(error);
  if (hasDuplicateMessage(error, graphQLErrors)) return 'alreadyRequested';

  const codes = graphQLErrors.map((item) => Number(item?.errorInfo?.code));
  if (codes.includes(CODE_CAMERA_NOT_FOUND)) return 'cameraNotFound';
  if (codes.includes(CODE_INVALID_PARAMS)) return 'rangeNotAvailable';
  return 'generic';
};
